module.exports = __webpack_public_path__ + "./docs/img/big-icon-interface.175b0c1813a88e553b59c57d0d323167.svg";